import React from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';

import {
	IndicatorScrollView,
	IndicatorScrollViewProps,
	ScrollIndicatorInsets,
	ScrollIndicatorTheme,
} from './ScrollIndicator';

type Props = {
	children: React.ReactNode;
	contentContainerStyle?: StyleProp<ViewStyle>;
	style?: StyleProp<ViewStyle>;
	/** Where the design puts the scroll bar inside this modal's body; defaults to 8 clear. */
	indicatorInsets?: ScrollIndicatorInsets;
	/** Leave off for a body that already lays out its own gutter for the bar. */
	reserveGutter?: boolean;
	indicatorTheme?: ScrollIndicatorTheme;
	/** For a body holding text fields: keep the focused one above the keyboard. */
	avoidKeyboard?: IndicatorScrollViewProps['avoidKeyboard'];
};

/** The redesigned modals' scrolling body: a vertical scroll view with the design's scroll bar. */
export const RedesignScrollView = ({
	children,
	contentContainerStyle,
	style,
	indicatorInsets,
	reserveGutter,
	indicatorTheme,
	avoidKeyboard,
}: Props) => (
	<IndicatorScrollView
		style={[styles.root, style]}
		contentContainerStyle={contentContainerStyle}
		indicatorInsets={indicatorInsets}
		reserveGutter={reserveGutter}
		indicatorTheme={indicatorTheme}
		avoidKeyboard={avoidKeyboard}
		keyboardShouldPersistTaps={avoidKeyboard ? 'handled' : undefined}
	>
		{children}
	</IndicatorScrollView>
);

const styles = StyleSheet.create({
	root: { flex: 1, minHeight: 0 },
});

export default RedesignScrollView;
